/* eslint-disable max-lines */
/* global window location navigator */
import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import Auth from '../../Auth';
import { get } from '../../server';
import NinjaLib from 'Components/TrackerProvider/NinjaLib';
import { urls, CATEGORY_REQUIRED_HEADERS } from 'Reducers/categories';
import { selectMappedCategories } from 'Selectors/categories';
import { itemsMetadataSelector, adCountSelector } from 'Selectors/items';
import compact from 'lodash/compact';
import { buildObjectFromURL } from 'Helpers/url';
import { supportLocalStorage } from 'Helpers/localStorage';
import {
    getItem as getSessionStorageItem,
    removeItem as removeSessionStorageItem
} from 'Helpers/sessionStorage';
import { selectedLocationSelector } from 'Selectors/location';
import { COUNTRY } from 'Constants/locations';
import {
    // APP_OPEN,
    LOCATION_APP_OPEN,
    DEFAULT_FROM,
    locationTypes,
    VIEW_LISTINGS,
    LISTINGS_RESULTS,
    LISTINGS_RESULTS_TIME,
    MOENGAGE_USER_PROPERTIES,
    LOGIN_SIGN_IN_COMPLETE,
    LOGIN_SIGN_OUT,
    FLOW_TYPE_EVENTS,
    VIEW_LISTINGS_IMPRESSIONS
} from 'Constants/tracking';
import { withConfig } from 'HOCs/withConfig/withConfig';
import { ContextTrackProvider } from './TrackerContext';
import withCookies from 'HOCs/withCookies/withCookies';
import CookieManager from 'Helpers/cookies';
import { isEmpty } from 'Helpers/objects';
import { getSessionLong } from 'Helpers/userSession';
import {
    destroyMESession,
    getDefaultMEProperties,
    getMEPropertiesFromUserObj,
    identifyUserInMoengage
} from 'Helpers/moengage';
import { getQuickFiltersByName, getCurrentSorting, getRelaxedFiltersList } from 'Selectors/filtersTanak';
import { setFromBundleResultsetType } from 'Actions/track';
import { getSelectedLang } from 'Selectors/getLanguages';
import { getCountryData } from 'Selectors/config';
import { noop } from 'Helpers/function';
import { EvaluationConstants, LayoutSelector, LayoutHelper, CampaingHelpers } from 'olx-autos-landing-page';
import { getCityLocationId } from 'Helpers/locations';
import { PLATFORM } from 'Constants/device.APP_TARGET';
import { verifyRedirectionParameters } from 'Helpers/track';
import { MARKETING_CAMPAIGNS_MAPPING, CAMPAIGN_DATA } from 'Constants/sellCarO2O';

import withVwo from 'HOCs/withVwo/withVwo';
import withTrack from 'HOCs/withTrack/withTrack';
import { getVariantData } from 'Helpers/vwoTrackParam';
import { EXPERIMENT_HOME_PAGE } from 'Pages/HomeExperiment/constants';

export const TrackerOrigins = {
    SETTINGS: 'settings',
    SEARCH: 'search',
    BROWSE: 'browse',
    BROWSE_SEARCH: 'browse_search',
    HOME: 'home',
    PROFILE: 'profile',
    DRAWER: 'drawer',
    ON_BOARDING: 'on_boarding',
    POSTING: 'posting',
    EDITION: 'edition',
    REPUBLISH: 'republish',
    NOTIFICATIONS: 'notifications',
    MY_NETWORK: 'mynetwork',
    CHAT: 'chat',
    HOME_BANNER: 'home_banner',
    WIDGET_HOME: 'widget_home',
    ITEM_PAGE: 'item_page',
    ITEM: 'item',
    VIEW_ITEM: 'view_item',
    MAKE_CALL: 'make_call',
    FEATURE_REACTIVATION: 'feature_reactivation',
    EXTERNAL: 'external',
    DIRECT: 'direct',
    HEADER: 'header',
    MY_ADS: 'my_ads',
    MY_FAVOURITES: 'my_favourites',
    LISTING: 'listing',
    HEADER_DROPDOWN: 'header_dropdown',

    MY_PROFILE: 'myprofile',
    CHANGE_PASSWORD: 'change_password',
    PLACEHOLDER: 'placeholder',
    PRIVACY: 'privacy',
    ABOUT_BUILDER: 'about_builder',
    ALL_PROJECTS: 'all_projects',
    NEWLY_LAUNCHED: 'newly_launched',
    UNDER_CONSTRUCTION: 'under_construction',
    READY_TO_MOVE: 'readytomove',
    DISCLAIMER: 'disclaimer',
    OTHER_IMPORTANT_THINGS: 'other_important_things',
    DESCRIPTION: 'description',
    ONE_BHK: '1 BHK',
    TWO_BHK: '2 BHK',
    THREE_BHK: '3 BHK',
    FOUR_BHK: '4 BHK',
    FIVE_BHK: '5 BHK',
    SIX_BHK: '6 BHK',
    SEVEN_BHK: '7 BHK',
    EIGHT_BHK: '8 BHK',
    MY_ACCOUNT: 'my_account',
    CHANGE_LOCATION: 'change_location',
    ENLARGE_VIEW: 'enlarge_view',
    PD_PAGE_VIEW: 'pd_page_view',
    PD_PAGE: 'pd_page',
    AMENITIES: 'amenities',
    PROFILE_BAR: 'profile_bar',
    LOGIN: 'login',
    HATS_HOME: 'hats_home',
    DEEPLINK: 'deeplink',
    ANDROID: 'android',
    CMC: 'cmc',
    MYADS_BANNER: 'myads_banner',
    COVER_PAGE: 'cover_page',
    CHAT_INTERVENTION: 'chat_intervention',
    OLX_AUTOS_HOME: 'olx_autos_home',
    AUTOS_HOME_PAGE_WIDGET: 'homepage_widget',
    REPORT_AD: 'report_ad',
    REPORT_USER: 'report_USER',
    FOLLOW: 'follow',
    CHAT_REPLY: 'chat_reply',
    NOTIFICATION: 'notification',
    FAVOURITE: 'favourite',
    PAID_DIRECT: 'paid_direct',
    ORGANIC_DIRECT: 'organic_direct',
    LISTING_LOAD: 'listing_load',
    e: 'email',
    s: 'sms',
    n: 'notification',
    LOGIN_ALERT_NOTIFICATION: 'login_alert_notification',
    LOGIN_ALERT_EMAIL: 'login_alert_email',
    LOGIN_ALERT_SMS: 'login_alert_sms',
    MY_ZONE: 'my_zone',
    GET_STARTED: 'get_started',
    ALL_ACTIVITIES: 'all_activities',
    RESERVED: 'reserved',
    TEST_DRIVE: 'testDrive',
    SHORTLIST: 'shortlist',
    ads: 'ads',
    about: 'about',
    photos: 'photos',
    contact: 'contact',
    connections: 'connections',
    PACKAGE_VIEW: 'package view',
    CHECKOUT_PAGE: 'checkout page',
    BENEFITS_HOMEPAGE: 'benefits homepage',
    INSURANCE_LIST_PAGE: 'insurance list page',
    WARRANTY_LIST_PAGE: 'warranty list page',
    VOUCHER_LIST_PAGE: 'voucher list page',
    LISTING_PAGE: 'listing_page'
};

const resultSetIdEvents = {
    item_chat_tap_send_offer: true,
    item_chat_tap_chat: true,
    item_intent_chat: true,
    item_chat_tap_send_1st_reply: true,

    view_listings: true,
    listings_results: true,
    listings_results_time: true,
    view_listings_impressions: true,

    view_item: true,
    view_item_time: true,
    carousel_listings_results: true,
    carousel_view_listings: true,

    item_tap_call: true,
    item_call_button_press: true,
    item_intent_call: true,
    item_tap_phone: true,

    item_chat_tap_sms: true,

    inspected_car_icon: true
};

const getAppliedCategoryId = ({ applied_filters = [] } = {}) => {
    const [categoryFilter] = applied_filters.filter(filter => filter.id === 'category');
    const appliedCategory = categoryFilter && categoryFilter.values[0];

    if (!appliedCategory || !appliedCategory.id) {
        return {};
    }

    return {
        category_id: appliedCategory.id
    };
};

export class TrackerProvider extends React.Component {
    static propTypes = {
        properties: PropTypes.object.isRequired,
        children: PropTypes.any,
        categories: PropTypes.array,
        trackBrowsingMode: PropTypes.string,
        trackFiltersMetadata: PropTypes.object,
        itemsMetadata: PropTypes.object,
        user: PropTypes.object,
        selectedLocation: PropTypes.shape({
            id: PropTypes.number,
            latitude: PropTypes.number,
            longitude: PropTypes.number,
            gps: PropTypes.object,
            type: PropTypes.string,
            name: PropTypes.string
        }),
        gps: PropTypes.object,
        marketConfig: PropTypes.shape({
            get: PropTypes.func.isRequired
        }).isRequired,
        cookies: PropTypes.shape({
            get: PropTypes.func.isRequired
        }),
        currentSorting: PropTypes.string,
        countryId: PropTypes.any,
        adCounts: PropTypes.object,
        quickFilters: PropTypes.string,
        trackOrigin: PropTypes.string,
        trackFlowStep: PropTypes.string,
        currBundleResultsetType: PropTypes.string,
        fromBundleResultsetType: PropTypes.string,
        setFromBundleResultsetType: PropTypes.func,
        getSelectedLang: PropTypes.string,
        countryData: PropTypes.object,
        trackingOrigin: PropTypes.string,
        clientIpPort: PropTypes.string,
        relaxedFiltersList: PropTypes.array,
        vwoClientInstance: PropTypes.shape({
            activate: PropTypes.func,
            track: PropTypes.func
        })
    };

    static defaultProps = {
        trackBrowsingMode: '',
        trackFiltersMetadata: {},
        itemsMetadata: {},
        user: {},
        selectedLocation: {},
        adCounts: {},
        trackOrigin: '',
        currBundleResultsetType: '',
        fromBundleResultsetType: '',
        countryData: {},
        setFromBundleResultsetType: noop,
        trackingOrigin: '',
        clientIpPort: '',
        relaxedFiltersList: []
    };

    constructor(props) {
        super(props);

        this.properties = {
            breakpoint: 768,
            ...props.properties
        };

        this.state = {
            libLoaded: false
        };

        const currentPathname = this.properties.location.pathname + this.properties.location.search;

        this.browsingModeEvents = this.props.marketConfig.get('browsingModeEvents');
        this.isMxCl = props.marketConfig.get('adpvAuto', 'showMXDesign');
        this.impressions = {
            limit: props.marketConfig.get('realImpressions').limit,
            pending: {
                [currentPathname]: []
            },
            bundlesPending: {
                [currentPathname]: []
            },
            currentSearchType: null,
            currentPathname
        };

        this.trackingParamsQueue = [];
        this.serverSideFlag = true;

        if (typeof window !== 'undefined') {
            if (typeof document !== 'undefined' && document.readyState === 'complete') {
                setTimeout(() => {
                    this.loadTracking();
                }, 0);
            }
            else {
                window.addEventListener('load', () => {
                    this.loadTracking();
                }, false);
            }
        }

        CampaingHelpers.setSessionUtmParams(this.properties.location, this.props.marketConfig?.get());
    }

    componentDidMount() {
        window.addEventListener('beforeunload', this.unloadEventHandler());
        this.startTime = Date.now();
    }

    shouldComponentUpdate(newProps, newState) {
        if ((newState.libLoaded !== this.state.libLoaded) || this.onNewPageNow()) {
            return true;
        }

        const { properties, children, categories } = this.props;

        return properties !== newProps.properties
            || children !== newProps.children
            || categories.length !== newProps.categories.length;
    }

    componentDidUpdate(prevProps) {
        const { currentPathname: prevCurrentPathname } = this.impressions;
        const { itemsMetadata } = prevProps;

        this.trackImpressions(itemsMetadata, 'listings');
        this.trackImpressions(itemsMetadata, 'bundles');

        this.updateCurrentPathname();
        this.updateCurrentSearchType();

        // flushes the pending impressions of the prev currentPathname
        this.setImpressionsPending({
            [prevCurrentPathname]: []
        });
        this.setBundlesImpressionPending({
            [prevCurrentPathname]: []
        });
        this.startTime = Date.now();
    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.unloadEventHandler());
    }

    loadTracking() {
        if (typeof window !== 'undefined') {
            window.dataLayer = window.dataLayer || [];

            this.trackAppOpen();
            this.trackLocationAppOpen();

            setTimeout(() => {
                this.performancePwaLoad();
            }, 0);

            const events = ['deviceFingerPrintGenerated', 'trackingLibraryLoaded'];

            events.forEach(event => {
                window.addEventListener(event, () => {
                    this.trackFromQueue();
                });
            });
        }
    }

    getImpressions = () => {
        const { pending, bundlesPending } = this.impressions;

        return {
            pending,
            bundlesPending
        };
    }

    unloadEventHandler() {
        const { itemsMetadata } = this.props;

        this.trackImpressions(itemsMetadata, 'listing');
        this.trackImpressions(itemsMetadata, 'bundles');
    }

    getTrackingInfo() {
        const { trackingOrigin } = this.props;
        const defaultProperty = {
            origin: trackingOrigin,
            user_type: CookieManager.readCookie(EvaluationConstants.REPEAT_USER_COOKIE_NAME) ? 2 : 1,
            reason: CookieManager.readCookie(EvaluationConstants.SELLER_STATE_COOKIE) || '',
            browsing_mode: this.props.trackBrowsingMode,
            ...LayoutHelper.getAcquisitionChannelTrackingValues()
        };

        return defaultProperty;
    }

    trackAppOpen() {
        const firstTrackingDispatchEvent = () => {
            const firstTrackingCreatedEvent = document.createEvent('Event');

            firstTrackingCreatedEvent.initEvent('firstTrackingCreated', true, true);

            window.dispatchEvent(firstTrackingCreatedEvent);
        };
        const target_url = [
            window.location.pathname,
            window.location.search,
            window.location.hash
        ].join('');

        if (typeof navigator !== 'undefined' && typeof navigator.permission !== 'undefined') {
            navigator.permissions.query({ name: 'geolocation' })
                .then(result => result.state)
                .then(geolocationState => {
                    navigator.permissions.query({ name: 'notifications' })
                        .then(result => {
                            this.setTrack('app_open', {
                                geo_permissions: geolocationState,
                                notification_permissions: result.state,
                                target_url,
                                ...(window.location.pathname === '/' ? { ...getVariantData(this.props.vwoClientInstance, EXPERIMENT_HOME_PAGE) } : {})
                            }, null, true);

                            firstTrackingDispatchEvent();
                        });
                });
        }
        else {
            this.setTrack('app_open', { target_url, ...(window.location.pathname === '/' ? { ...getVariantData(this.props.vwoClientInstance, EXPERIMENT_HOME_PAGE) } : {})
            }, null, true);
            firstTrackingDispatchEvent();
        }
    }

    trackLocationAppOpen = () => {
        const { selectedLocation } = this.props;

        if (selectedLocation) {
            const trackProps = { select_from: DEFAULT_FROM };

            if (selectedLocation.gps && selectedLocation.gps.currentLocation) {
                trackProps.location_type = locationTypes.NEAR_ME;
            }
            else if (selectedLocation.type === COUNTRY) {
                trackProps.location_type = locationTypes.DEFAULT;
                trackProps.place_selected_id = selectedLocation.id;
            }
            else {
                trackProps.location_type = locationTypes.PRESET;
                trackProps.place_selected_id = selectedLocation.id;
            }

            this.setTrack(LOCATION_APP_OPEN, trackProps);
        }
    }

    trackFromQueue() {
        if (typeof window !== 'undefined'
            && typeof window.dataLayer !== 'undefined'
            && typeof window.trackingLibraryLoaded !== 'undefined'
            && window.trackingLibraryLoaded === true
            && typeof window.deviceFingerPrintGenerated !== 'undefined'
            && window.deviceFingerPrintGenerated === true) {
            let trackingValue;

            const dfp = window.localStorage.getItem('device_fingerprint');

            while (this.trackingParamsQueue.length > 0) {
                trackingValue = this.trackingParamsQueue.shift();
                trackingValue.device_fingerprint = dfp;

                const trackingObject = {
                    cleanup() {
                        window.dataLayer.push(trackingValue);
                        trackingValue.callback();
                    }
                };

                window.dataLayer.push(trackingObject);
            }
        }
    }

    updateCurrentPathname = () => {
        this.impressions.currentPathname = this.getCurrentPathname();
    }

    updateCurrentSearchType = () => {
        this.impressions.currentSearchType = getSessionStorageItem('search_type');
        removeSessionStorageItem('search_type');
    }

    /**
     * Fetches the current pathname using the browser's lcoation api
     */
    getCurrentPathname = () => {
        return location.pathname + location.search;
    }

    onNewPageNow = () => this.impressions.currentPathname !== this.getCurrentPathname();

    getCurrentPendingImpressions = () => {
        const { pending, currentPathname } = this.impressions;
        const currentPendingImpressions = pending[currentPathname];

        if (typeof currentPendingImpressions === 'undefined') {
            this.impressions.pending[currentPathname] = [];
            return (this.impressions.pending[currentPathname]);
        }

        return currentPendingImpressions;
    }

    getCurrentPendingBundlesImpressions = () => {
        const { bundlesPending, currentPathname } = this.impressions;
        const pendingImpressions = bundlesPending[currentPathname];

        if (typeof pendingImpressions === 'undefined') {
            this.impressions.bundlesPending[currentPathname] = [];
            return (this.impressions.bundlesPending[currentPathname]);
        }
        return pendingImpressions;
    };

    getCurrentTrackedImpressions = () => {
        const { tracked, currentPathname } = this.impressions;
        const currentTrackedImpressions = tracked[currentPathname];

        if (typeof currentTrackedImpressions === 'undefined') {
            return (this.impressions.tracked[currentPathname] = []);
        }

        return currentTrackedImpressions;
    }

    setImpressionsPending = obj => {
        this.impressions.pending = { ...this.impressions.pending, ...obj };
    }

    setBundlesImpressionPending = obj => {
        this.impressions.bundlesPending = { ...this.impressions.bundlesPending, ...obj };
    }

    /**
     * finds a impression in the current pending list
     * based on id of the impression
     */
    isImpressionAlreadyRecorded = (list, imp) => {
        if (!Array.isArray(list)) {
            return false;
        }
        return list.find(elem => elem && elem.id === imp.id);
    }

    /**
     * Provides some trackoing info/attirbutes based on the this.impressions.currentPathname url
     */
    trackUrlProperties = () => {
        const { currentPathname } = this.impressions;

        const {
            search,
            params: { filters, sorting, ...res } = {},
            category,
            path
        } = buildObjectFromURL(currentPathname);
        const { relaxedFiltersList, itemsMetadata } = this.props;
        const { longitude: lon, latitude: lat, id } = this.props.selectedLocation;
        const trackProps = {
            resultset_type: (filters || search) ? 'search' : 'browse',
            origin: (path === '/') ? TrackerOrigins.HOME : TrackerOrigins.BROWSE
        };

        if (this.props.fromBundleResultsetType) {
            // tracking for listings_result
            trackProps.resultset_type = this.props.fromBundleResultsetType;
        }

        if (lat && lon && id) {
            trackProps.filters = { location: { id, lat, lon }};
        }

        if (sorting) {
            trackProps.sorting_applied = sorting;
        }

        if (filters) {
            trackProps.filters = {
                ...trackProps.filters,
                ...filters,
                ...res
            };
            trackProps.filter_count = isEmpty(filters) ? 0 : Object.keys(filters).length;
            trackProps.applied_filters = isEmpty(filters) ? '' : Object.keys(filters).join(',');
            trackProps.relaxed_filters = Array.isArray(relaxedFiltersList) ? relaxedFiltersList.toString() : '';
        }

        if (itemsMetadata.removed_term) {
            trackProps.relaxed_filters = trackProps.relaxed_filters ? `${trackProps.relaxed_filters},${itemsMetadata.removed_term}` : itemsMetadata.removed_term;
        }

        if (search) {
            if (this.impressions.currentSearchType) {
                trackProps.search_type = this.impressions.currentSearchType;
            }
            trackProps.search_string = search;
            trackProps.origin = TrackerOrigins.SEARCH;
            trackProps.filters = {
                ...trackProps.filters,
                text: search
            };
        }

        if (search && filters) {
            trackProps.origin = TrackerOrigins.BROWSE_SEARCH;
        }

        if (category) {
            trackProps.category_id = category.id;
            trackProps.filters = {
                ...trackProps.filters,
                category: category.id
            };
        }

        // Set origin from props instead of based on url
        if (this.props.trackOrigin) {
            trackProps.requestOrigin = trackProps.origin;
            trackProps.origin = this.props.trackOrigin;
        }

        return trackProps;
    }

    /**
     * Transform and divides the impressions list into sub-lists,(ie. batches)
     * where each sublist will have max size of `limit`
     */
    getImpressionsBatches = impressions => {
        const { limit } = this.impressions;
        const batches = compact(impressions)
            .reduce((accumulatedBatches, { id, isFeatured, spell_id = 0, isInspected }, idx) => {
                if (idx % limit === 0) {
                    const batch = {
                        impressions: [`${isFeatured ? 'T' : 'O'}${spell_id}:${id}`],
                        inspectedAdsCount: isInspected ? 1 : 0,
                        featuredAdsCount: isFeatured ? 1 : 0
                    };

                    accumulatedBatches.push(batch);
                }
                else {
                    const batch = accumulatedBatches[accumulatedBatches.length - 1];

                    batch.impressions.push(`${isFeatured ? 'T' : 'O'}${spell_id}:${id}`);
                    batch.inspectedAdsCount = isInspected ? batch.inspectedAdsCount + 1 : batch.inspectedAdsCount;
                    batch.featuredAdsCount = isFeatured ? batch.featuredAdsCount + 1 : batch.featuredAdsCount;
                }
                return accumulatedBatches;
            }, []);

        return batches;
    }

    /**
     * Receives an item impression when viewed on screen and
     * appended it to the list of pending impressions if applicable
     *
     */
    addImpression = impression => {
        if (typeof window !== 'undefined' && typeof impression !== 'undefined') {
            const { currentPathname } = this.impressions;
            const currentPendingImpressions = this.getCurrentPendingImpressions();

            // if the impression is already recording
            // dont waste anymore time on it
            if (!this.isImpressionAlreadyRecorded(currentPendingImpressions, impression)) {
                this.setImpressionsPending({
                    [currentPathname]: [...currentPendingImpressions, impression]
                });
            }
        }
    };

    addBundlesImpression = impression => {
        if (typeof window !== 'undefined' && typeof impression !== 'undefined') {
            const { currentPathname } = this.impressions;
            const pendingImpressions = this.getCurrentPendingBundlesImpressions();

            if (!this.isImpressionAlreadyRecorded(pendingImpressions, impression)) {
                this.setBundlesImpressionPending({
                    [currentPathname]: [...pendingImpressions, impression]
                });
            }
        }
    };

    /**
     * Pushes the pending impressions for this.impressrions.currentPathname url
     * for tracking under the `view_listings` events
     */
    trackImpressions = (itemsMetadata, type) => {
        // get the pending impressions for the this.impressions.pathname url
        const pendingImpressions = (type === 'bundles')
            ? this.getCurrentPendingBundlesImpressions() : this.getCurrentPendingImpressions();

        // no pending impresssions? nothing to do then, bye!
        if (!pendingImpressions || pendingImpressions.length <= 0) {
            return false;
        }

        const impressionsBatches = this.getImpressionsBatches(pendingImpressions);

        let trackInfo = {
            city_id: getCityLocationId(this.props.selectedLocation)
        };

        if (type === 'bundles') {
            const { currentPathname } = this.impressions;
            const { path } = buildObjectFromURL(currentPathname);
            const { longitude: lon, latitude: lat, id } = this.props.selectedLocation;
            const { category_id = '' } = getAppliedCategoryId(itemsMetadata);

            trackInfo = {
                ...trackInfo,
                origin: (path === '/') ? TrackerOrigins.HOME : TrackerOrigins.BROWSE,
                resultset_type: this.props.currBundleResultsetType
            };

            if (lat && lon && id) {
                trackInfo.filters = { location: { id, lat, lon }};
            }

            if (category_id) {
                trackInfo = {
                    ...trackInfo,
                    ...this.getCategoryTree({ category_id })
                };
            }
        }
        else {
            const { category_id = '' } = itemsMetadata;
            const { marketConfig } = this.props;
            const visualizationType = marketConfig.get('visualizationType', PLATFORM);

            trackInfo = {
                ...trackInfo,
                ...this.trackUrlProperties(),
                ...this.props.trackFiltersMetadata,
                ...this.addSuggestedTermInfo(itemsMetadata),
                ...this.getCategoryTree({ category_id }),
                ...getAppliedCategoryId(itemsMetadata),
                ...this.getQuickFiltersValues(this.props.quickFilters),
                visual_applied: visualizationType,
                sorting_applied: this.props.currentSorting,
                feed_version: itemsMetadata.feed_version
            };
            if (this.props.fromBundleResultsetType) {
                this.props.setFromBundleResultsetType('');
            }
        }

        impressionsBatches.forEach((batch, index) => {
            this.setTrack(VIEW_LISTINGS, {
                ...trackInfo,
                impressions: batch.impressions,
                result_count: batch.impressions.length,
                inspected_ad_count: batch.inspectedAdsCount,
                fa_ad_count: batch.featuredAdsCount,
                page_number: index,
                ...LayoutHelper.getAcquisitionChannelTrackingValues(),
                ...getVariantData(this.props.vwoClientInstance, EXPERIMENT_HOME_PAGE)
            });
        });

        if (type === 'listings') {
            trackInfo.time_spent = Math.floor((Date.now() - this.startTime) / 1000); // eslint-disable-line no-magic-numbers
            this.setTrack(LISTINGS_RESULTS_TIME, {
                ...trackInfo,
                ...LayoutHelper.getAcquisitionChannelTrackingValues()
            });
        }
        return null;
    };

    addSuggestedTermInfo(itemsMetadata) {
        const {
            show_suggested_items,
            suggested_term: search_string_suggested,
            total_suggested_pages: total_pages_suggested,
            total_suggested_ads: suggested_ads_count
        } = itemsMetadata;

        if (show_suggested_items && search_string_suggested) {
            return {
                search_string_suggested,
                total_pages_suggested,
                suggested_ads_count
            };
        }
        return {};
    }

    trackListingsResultsProps = (page_number = 0, location = {}) => {
        const { itemsMetadata = {}, adCounts, quickFilters, selectedLocation, marketConfig } = this.props;
        const visualizationType = marketConfig.get('visualizationType', PLATFORM);
        const trackProps = {
            ...this.trackUrlProperties(),
            sorting_applied: this.props.currentSorting,
            visual_applied: visualizationType
        };
        const {
            feed_version = '-',
            total_pages = null,
            total: result_count,
            total_similar_ads: relaxed_result_count
        } = itemsMetadata;
        const { inspected_ad_count, fa_ad_count } = adCounts;

        const { query } = this.properties.location || {};
        const redirectionTrackingInfo = verifyRedirectionParameters(query) || {};

        const trackInfo = {
            ...trackProps,
            ...this.props.trackFiltersMetadata,
            ...this.getQuickFiltersValues(quickFilters),
            result_count,
            images_count: relaxed_result_count,
            page_number,
            total_pages,
            feed_version,
            inspected_ad_count,
            fa_ad_count,
            ...this.addSuggestedTermInfo(itemsMetadata),
            ...getAppliedCategoryId(itemsMetadata),
            select_from: location?.state?.select_from,
            city_id: getCityLocationId(selectedLocation),
            ...redirectionTrackingInfo,
            ...LayoutHelper.getAcquisitionChannelTrackingValues()
        };

        return trackInfo;
    }

    /**
     * @param page_number {number} the index for which the listing result is to be fired
     * @param onMounted {bool} - flag if the event is called on componentDidMount of withItems HOC
     */
    trackListingRequest = (page_number = 0, onMounted = false, location = {}) => {
        // if the function is called from the componentDidMount of withItems HOC
        // we have to fire the event only for listing result obtained during SSR
        // after that if any onMountedFlag is received, we ignore the event request
        /* istanbul ignore if */
        if (onMounted) {
            if (!this.serverSideFlag) {
                return null;
            }
            this.serverSideFlag = false;
        }

        const trackInfo = this.trackListingsResultsProps(page_number, location);

        return this.setTrack(LISTINGS_RESULTS, trackInfo);
    };

    trackViewListingsImpressions = (params, page_number = 0, location = {}) => {
        const trackProps = this.trackListingsResultsProps(page_number, location);
        const trackInfo = {
            ...trackProps,
            ...params
        };

        return this.setTrack(VIEW_LISTINGS_IMPRESSIONS, trackInfo);
    };

    setTrack = (name, params, callback = () => { }, trackDataLayer = false) => {
        this.setState({
            libLoaded: true
        }, () => {
            this.track(name, params, callback, trackDataLayer);
        });
    };

    validateOrigin = origin => (!!Object.values(TrackerOrigins).find(key => origin === key));

    checkAddToHome = () => (typeof window !== 'undefined' && window.location.href.indexOf('install') > -1);

    getDefaultParams = name => {
        const liveLocationArray = this.props.gps.location;
        let lat;
        let long;

        if (!isEmpty(liveLocationArray)) {
            lat = liveLocationArray[0].latitude;
            long = liveLocationArray[0].longitude;
        }
        else if (name !== LOGIN_SIGN_IN_COMPLETE) {
            lat = this.props.selectedLocation.latitude;
            long = this.props.selectedLocation.longitude;
        }

        const sendAnalyticsId = this.props.marketConfig.get('sendAnalyticsId') || false;
        const appKey = this.props.marketConfig.get('chat')?.newChat?.appkey ? 'olxautos' : 'classifieds';

        return ({
            country_code: this.properties.location.hostname.split('.').pop().toLowerCase(),
            business_region: this.properties.region,
            language: this.properties.lang,
            platform_type: this.properties.platformType,
            ts: Date.now(),
            user_status: 'anonimous',
            brand: 'olx',
            lat,
            long,
            app_version: process.env.PWA_VERSION,
            add_to_home: this.checkAddToHome(),
            app_language: this.properties.app_language,
            isOnline: window && window.navigator && window.navigator.onLine,
            c_add: this.props.clientIpPort,
            browsing_mode: appKey,
            ...(sendAnalyticsId && this.getGoogleAnalyticsParams())
        });
    };

    getQuickFiltersValues = quickFilters => {
        return quickFilters ? { quick_filters: quickFilters } : {};
    }

    getCategoryTree = ({ category_id }) => {
        let categoriesL1 = {};
        let categoriesL2 = {};

        if (this.props.categories && category_id) {
            const l1 = this.props.categories.find(category => category.id === category_id);

            if (l1) {
                categoriesL1 = {
                    category_level1_id: l1.id,
                    category_level1_name: l1.key,
                    category_id: l1.id
                };
            }
            else {
                let l2;

                for (const l1 of this.props.categories) {
                    l2 = l1.sub_categories && l1.sub_categories.find(cat => cat.id === category_id);

                    if (l2) {
                        categoriesL1 = {
                            category_level1_id: l1.id,
                            category_level1_name: l1.key
                        };

                        categoriesL2 = {
                            category_level2_id: l2.id,
                            category_level2_name: l2.key,
                            category_id: l2.id
                        };

                        break;
                    }
                }
            }
        }

        return { ...categoriesL1, ...categoriesL2 };
    };

    getExperimentsParams = () => {
        const { cookies } = this.props;
        const laquesis = cookies.get('laquesis');

        if (laquesis?.length > 0) {
            return {
                experiment_variant: laquesis.split('#').join(',')
            };
        }
        return {};
    };

    getGoogleAnalyticsParams = () => {
        const { cookies } = this.props;
        const gid = cookies.get('_gid');

        if (gid && gid.length) {
            return {
                google_analytics_id: gid
            };
        }
        return null;
    }

    initME = (name, user, deviceFP) => { // ,
        const sessionCookie = CookieManager.readCookie('onap') || CookieManager.readCookie('onap_dev');
        const sessionLongByCookie = sessionCookie ? getSessionLong(sessionCookie) : '';
        const { countryData, getSelectedLang } = this.props;
        const { countryName, countryIsoCode } = countryData; // countryBrand
        const defaultProperties = getDefaultMEProperties(sessionLongByCookie, countryName, countryIsoCode, getSelectedLang, deviceFP);

        if (name === LOGIN_SIGN_IN_COMPLETE) {
            const { userData } = this.props.user;
            const userObj = userData && userData.user || {};

            const userProperties = {
                ...getMEPropertiesFromUserObj(userObj),
                ...this.getLoginUserAuthProperties(this.props.user),
                ...defaultProperties
            };

            Object.keys(userProperties).forEach(key => (!userProperties[key] || typeof userProperties[key] !== 'string') && delete userProperties[key]);

            identifyUserInMoengage(userProperties);
        }
        else if (name && name.indexOf(LOGIN_SIGN_OUT) > -1) {
            destroyMESession();
        }
    };

    getLoginUserAuthProperties() {
        const properties = {};
        const { userData } = this.props.user;

        if (userData && userData.authToken) {
            const { action, email, phone, clientType, isNewUser } = userData.authToken;

            properties[MOENGAGE_USER_PROPERTIES.LAST_LOGIN_PLATFORM] = clientType;
            properties[MOENGAGE_USER_PROPERTIES.LAST_LOGIN_MODE] = action;

            if (email) {
                properties[MOENGAGE_USER_PROPERTIES.EMAIL] = email;
            }
            if (phone) {
                properties[MOENGAGE_USER_PROPERTIES.PHONE] = phone;
            }
            if (isNewUser) {
                properties[MOENGAGE_USER_PROPERTIES.REG_PLATFORM] = clientType;
            }
        }
        return properties;
    }

    getCampaignData = () => {
        const campaignsParams = {};
        let campaign_data = {};

        if (getSessionStorageItem(CAMPAIGN_DATA)) {
            campaign_data = JSON.parse(getSessionStorageItem(CAMPAIGN_DATA));
            const queryJSON = Object.keys(campaign_data);

            if (queryJSON?.length) {
                for (const key of MARKETING_CAMPAIGNS_MAPPING) {
                    if (campaign_data[key]) {
                        campaignsParams.campaign_click_ad = key;
                        campaignsParams.campaign_click_id = campaign_data[key];
                    }
                }
                campaignsParams.campaign_id = campaign_data['campaign_id'];
                campaignsParams.acquisition_channel_campaign_ad_group = campaign_data.group;
                campaignsParams.acquisition_channel_territory = campaign_data.territory;
                campaignsParams.country = campaign_data.country;
                campaignsParams.acquisition_channel_device = campaign_data.device;
                campaignsParams.acquisition_channel_network = campaign_data.network;
                campaignsParams.match_type = campaign_data.match_type;
                campaignsParams.ad_id = campaign_data['ad_id'];
                campaignsParams.target_id = campaign_data['target_id'];
                campaignsParams.group_id = campaign_data['group_id'];
                campaignsParams.campaign_url = campaign_data.landingURL;
                campaignsParams.campaign_type = campaign_data['campaign_type'];
            }
            return campaignsParams;
        }
        return null;
    }

    getCityName = () => {
        const liveLocationArray = this.props.gps.location;

        if (isEmpty(liveLocationArray)) {
            return undefined;
        }
        const location = liveLocationArray.filter(locationObj => locationObj.type === 'CITY');

        return location.length > 0 ? location[0].name : undefined;
    }

    track = (name, params = {}, callback = () => { }, trackDataLayer = false) => {
        if (typeof window === 'undefined') {
            return false;
        }

        callback = typeof callback === 'function' ? callback : () => { };

        const user = Auth?.getUser();

        if (user) {
            params.user_id = user.id;
            params.user_status = 'logged_in';
        }
        if (name === LOGIN_SIGN_IN_COMPLETE) {
            params.login_city = this.getCityName();
        }
        if (supportLocalStorage()) {
            const deviceFP = window.localStorage.getItem('device_fingerprint');
            const postingLocation = window.localStorage.getItem('posting_location');

            if (deviceFP) {
                params.device_fingerprint = deviceFP;
            }
            if (postingLocation) {
                const parsedLocation = JSON.parse(postingLocation);

                params.neighbourhood_id = parsedLocation.locality;
                params.city_id = parsedLocation.city;
                params.region_id = parsedLocation.state;
                params.country_id = this.props.countryId;
            }
            this.initME(name, user, deviceFP);
        }

        const defaultParams = Object.assign({}, this.getDefaultParams(name), {
            trackPage: name
        });

        if (name?.indexOf('view_') < 0) {
            params = Object.assign({}, params, {
                trackEvent: [name]
            });

            delete defaultParams.trackPage;
        }
        else if (name === 'view_default') {
            let path = location.pathname.split('/').join('_');
            const maxPathLength = 4;

            if (path.indexOf('_edit') > -1) {
                path = '_edit';
            }

            if (path.indexOf('_item') > -1) {
                path = '_item';

                if (!params.item_id) {
                    return false;
                }
            }

            if (path.length < maxPathLength) {
                return false;
            }

            defaultParams.trackPage = `view${path}`;
        }

        if (resultSetIdEvents[name]) {
            const { resultset_id = 'null' } = this.props.itemsMetadata;

            params.resultset_id = resultset_id;
        }

        if (FLOW_TYPE_EVENTS[name]) {
            params.flow_step = this.props.trackFlowStep;
            params.flow_type = this.props.trackFlowStep;
        }

        if (this.browsingModeEvents[name]) {
            params.browsing_mode = this.props.trackBrowsingMode;
        }

        if (params.origin) {
            const origin = this.validateOrigin(params.origin);

            if (!origin) {
                delete params.origin;
            }
        }

        const categories = this.getCategoryTree(params);
        const experimentsParams = this.getExperimentsParams();

        const allParams = {
            ...defaultParams,
            ...params,
            ...categories,
            ...experimentsParams,
            ...LayoutHelper.getAcquisitionChannelTrackingValues(), // add marketing params - utm_* ( acquisition_channel_medium_name, acquisition_channel_term_name etc for every tracking)
            ...this.getCampaignData()
        };

        try {
            /**
             * Only push event to dataLayer
             * if device_fingerprint is available
             */
            if (trackDataLayer && allParams.device_fingerprint) {
                const trackingObject = {
                    cleanup() {
                        window.dataLayer.push(allParams);
                        callback();
                    }
                };

                window.dataLayer.push(trackingObject);
            }
            else {
                this.trackingParamsQueue.push({
                    ...allParams,
                    trackDataLayer,
                    callback
                });
                this.trackFromQueue();
            }
        }
        catch (e) {
            console.error(e); // eslint-disable-line
        }

        return true;
    };

    performancePwaLoad() {
        const performance_pwa_load = {
            platform: 'PWA',
            performanceApi: false,
            connectionApi: false,
            paintApi: false,
            fidApi: false
        };
        const performance = window.performance || window.webkitPerformance || window.msPerformance || window.mozPerformance;
        const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection || null;
        const fid = window.fid;

        if (performance) {
            const performanceTiming = performance.timing ? performance.timing : null;
            const performancePaint = performance.getEntriesByType ? performance.getEntriesByType('paint') : [];

            if (performanceTiming) {
                performance_pwa_load.performanceApi = true;
                performance_pwa_load.first_byte = performanceTiming.responseStart - performanceTiming.fetchStart;
                performance_pwa_load.interactive = performanceTiming.domInteractive - performanceTiming.fetchStart;
                performance_pwa_load.dom_content_loaded = performanceTiming.domContentLoadedEventEnd - performanceTiming.fetchStart;
                performance_pwa_load.loaded = performanceTiming.loadEventEnd - performanceTiming.fetchStart;
            }

            if (performancePaint.length) {
                performance_pwa_load.paintApi = true;
                performancePaint.forEach(paint => {
                    performance_pwa_load[paint.name.replace(/-/g, '_')] = Math.round(paint.startTime);
                });
            }
        }

        if (connection) {
            performance_pwa_load.connectionApi = true;
            performance_pwa_load.connection_type = connection.effectiveType;
        }

        if (fid) {
            performance_pwa_load.fidApi = true;
            performance_pwa_load.fid_delay = Math.round(fid.delay);
            performance_pwa_load.fid_event = fid.event.type;
        }
        this.track('performance_load', performance_pwa_load);
    }

    contextValue = {
        app: this.props.properties,
        track: this.setTrack,
        trackerOrigins: TrackerOrigins,
        impressions: {
            add: this.addImpression,
            addBundlesImpression: this.addBundlesImpression,
            get: this.getImpressions
        },
        trackListingRequest: this.trackListingRequest,
        trackViewListingsImpressions: this.trackViewListingsImpressions
    }

    render() {
        const cleverTapId = this.props.marketConfig.get('clevertap', 'id');
        const gaId = this.props.marketConfig.get('ga', 'id');
        const gtmId = this.props.marketConfig.get('gtm', 'id');
        const moengageId = this.props.marketConfig.get('moengage', 'id');
        const ninjaLink = this.props.marketConfig.get('ninjaLink');
        const ninjaConfig = Object.assign({ cleverTapId, gaId, gtmId, moengageId }, this.props.properties.config);

        const lib = this.state.libLoaded ? (
            <NinjaLib
                environment={ this.props.properties.environment }
                hostname={ this.props.properties.location.hostname }
                alternateHostName={ this.props.properties.location.alternateHostName }
                config={ ninjaConfig }
                libraryLink={ ninjaLink }
            />
        ) : null;

        return (
            <ContextTrackProvider value={ this.contextValue } >
                {lib}
                {this.props.children}
            </ContextTrackProvider>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const itemsMetadata = itemsMetadataSelector(state);
    const { category_id } = getAppliedCategoryId(itemsMetadata);

    return {
        categories: selectMappedCategories(state),
        currBundleResultsetType: state.track.currBundleResultsetType,
        fromBundleResultsetType: state.track.fromBundleResultsetType,
        trackBrowsingMode: state.track.browsingMode,
        trackOrigin: state.track.origin,
        trackFiltersMetadata: state.track.filtersMetadata,
        trackFlowStep: state.track.flowStep,
        selectedLocation: selectedLocationSelector(state),
        relaxedFiltersList: getRelaxedFiltersList(state),
        quickFilters: getQuickFiltersByName(state, category_id),
        gps: state.locations.gps,
        countryId: state.locations.countryId,
        itemsMetadata,
        adCounts: adCountSelector(state),
        currentSorting: getCurrentSorting(state, category_id),
        getSelectedLang: getSelectedLang(state, ownProps),
        countryData: getCountryData(state),
        user: state.user,
        trackingOrigin: LayoutSelector.getTrackingOrigin(state, ownProps.location, ownProps.marketConfig),
        clientIpPort: state.api.clientIpPort || ''
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getCategories: () => dispatch(get(urls.getCategories, 'CATEGORIES', {}, CATEGORY_REQUIRED_HEADERS)),
        setFromBundleResultsetType: type => dispatch(setFromBundleResultsetType(type))
    };
};

export default compose(
    withConfig('marketConfig'),
    withCookies,
    withTrack,
    withVwo,
    connect(mapStateToProps, mapDispatchToProps)
)(TrackerProvider);
